function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#1991fd"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00e5ef"
})), React.createElement("linearGradient", {
  id: "b",
  x1: 0,
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  xlinkHref: "#a"
}), React.createElement("linearGradient", {
  id: "g",
  x1: 0.057,
  y1: 0.001,
  x2: 0.905,
  y2: 0.958,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#02eda7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3f56ee"
})), React.createElement("linearGradient", {
  id: "h",
  x1: 0.326,
  y1: 0.317,
  x2: 0.698,
  y2: 0.703,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0
}), React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "i",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0d9ff0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#62b2ff"
})), React.createElement("linearGradient", {
  id: "j",
  x1: 0.45,
  y1: 0.101,
  x2: 0.531,
  y2: 0.772,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#005dec"
}), React.createElement("stop", {
  offset: 0.159,
  stopColor: "#004cc2",
  stopOpacity: 0.824
}), React.createElement("stop", {
  offset: 0.576,
  stopColor: "#00235a",
  stopOpacity: 0.384
}), React.createElement("stop", {
  offset: 0.865,
  stopColor: "#000a19",
  stopOpacity: 0.11
}), React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1696.085 -943.227)"
}, React.createElement("g", {
  transform: "translate(1696.085 943.227)"
}, React.createElement("path", {
  d: "M1251.27,74.164q19.183,0,38.356-.084c11.052-.052,36.522-2.425,28.34-9.083-8.6-7-20.876-10.51-31.928-10.46-29.71.136-42.251.118-71.9-.034-.011,0-6.965-.042-12.645-7.226l-3.269,0c2.782,26.678,19.484,26.769,19.5,26.769C1227.114,74.093,1251.27,74.164,1251.27,74.164Z",
  transform: "translate(-1198.226 48.905)",
  fill: "#0dbaf7"
}), React.createElement("g", {
  transform: "translate(19.289)"
}, React.createElement("path", {
  d: "M1205.683,161.162c29.75-2.7,29.852-18.9,29.852-18.917.17-28.76.191-34.092.039-62.912-.057-10.722,3.863-22.629,11.665-30.97,7.422-7.938,18.891-12.647,30.441-12.713a45.3,45.3,0,0,1,30.934,11.974,37.309,37.309,0,0,1,11.877,27.484,37.606,37.606,0,0,1-12.956,27.089c-8.541,7.551-20.392,10.995-32.112,11.972-6.005.5-32.785-.613-39.749-.642l-.039,24.923s60.921,6,87.167-13.519c8.3-6.173,15.177-12.71,20.093-21.437a58.8,58.8,0,0,0,7.7-27.542c.333-15.79-6.186-31.617-17.883-43.424-17.029-17.184-45.595-25.583-70.646-20.512-15.261,3.09-29.391,10.678-39.477,21.424a62.287,62.287,0,0,0-16.207,32.89c-.919,5.922-.812,12.055-.762,17.99q.094,11.118.1,22.241c.037,20.02-.042,16.484-.031,36.5Q1205.7,152.113,1205.683,161.162Z",
  transform: "translate(-1205.591 -10.551)",
  fill: "url(#a)"
}), React.createElement("g", {
  transform: "translate(29.996 25.369)"
}, React.createElement("path", {
  d: "M1270.132,20.242a14.519,14.519,0,0,0-3.211.364s17.43,5.437,23.574,11.744c13.365,13.721,15.18,32.594,4.287,47.8-.267.372-1.391,1.8-1.684,2.153-8.541,10.29-20.982,14.557-34.831,15.9a144.78,144.78,0,0,1-21.4.144c-1.467-.076-19.826-.851-19.826-.749,0,0,3.332,25.033,26.489,25.921a133.98,133.98,0,0,0,34.113-3.5c13.5-3.145,23.066-6.223,36.235-18.839,7.069-6.773,10.91-16.2,12.864-25.308,1.849-8.609-.741-18.443-4.916-26.253a52.029,52.029,0,0,0-9.083-12.2,58.286,58.286,0,0,0-17.037-11.715,59.381,59.381,0,0,0-22.172-5.393C1272.455,20.278,1271.289,20.221,1270.132,20.242Z",
  transform: "translate(-1217.044 -20.237)",
  fill: "url(#b)"
}), React.createElement("g", {
  transform: "translate(3.465 21.221)"
}, React.createElement("path", {
  d: "M1319.711,36.5a51.191,51.191,0,0,0-5.447-8.164c.157.283.322.56.471.846,4.177,7.81,6.768,17.647,4.919,26.256-1.954,9.106-5.8,18.532-12.865,25.305-13.169,12.616-22.734,15.693-36.235,18.839a133.986,133.986,0,0,1-34.113,3.5,24.989,24.989,0,0,1-18.074-8.056c3.46,6.959,10.2,14.881,23.05,15.374a133.959,133.959,0,0,0,34.11-3.5c13.5-3.145,23.069-6.223,36.234-18.839,7.072-6.773,10.914-16.2,12.867-25.308C1326.476,54.148,1323.889,44.314,1319.711,36.5Z",
  transform: "translate(-1218.367 -28.34)",
  fill: "url(#b)"
}))), React.createElement("g", {
  transform: "translate(0.008)"
}, React.createElement("path", {
  d: "M1332.7,32.528c-17.026-17.184-45.592-25.583-70.644-20.512-15.263,3.09-29.393,10.678-39.479,21.424a62.3,62.3,0,0,0-16.2,32.89,77.254,77.254,0,0,0-.78,11.039A63.088,63.088,0,0,1,1218,58.068c10.086-10.746,24.216-18.333,39.477-21.424,25.051-5.07,53.616,3.329,70.646,20.512a60.907,60.907,0,0,1,17.846,40.035,57.788,57.788,0,0,0,4.614-21.24C1350.919,60.161,1344.4,44.334,1332.7,32.528Z",
  transform: "translate(-1205.594 -10.551)",
  fill: "url(#b)"
})), React.createElement("path", {
  d: "M1332.4,32.528c-17.029-17.184-45.592-25.583-70.646-20.512-15.261,3.09-29.391,10.678-39.477,21.424a62.283,62.283,0,0,0-16.207,32.89c-.17,1.108-.3,2.224-.412,3.345a62.9,62.9,0,0,1,14.031-23.742c10.086-10.746,24.216-18.333,39.477-21.424,25.054-5.07,53.617,3.329,70.646,20.512,11.7,11.807,18.215,27.633,17.885,43.424q-.043,1.953-.223,3.9a57.031,57.031,0,0,0,2.808-16.39C1350.62,60.161,1344.1,44.334,1332.4,32.528Z",
  transform: "translate(-1205.473 -10.551)",
  fill: "url(#b)"
}), React.createElement("path", {
  d: "M1235.625,93.026q0-17.2-.1-34.4A40.823,40.823,0,0,1,1247.193,30a39.462,39.462,0,0,1,13.058-8.352c-1.461-.126-2.933-.189-4.408-.181-11.55.06-23.019,4.413-30.441,11.752a40.8,40.8,0,0,0-11.665,28.631c.152,26.643.131,37.89-.039,64.476,0,.013-.045,6.246-8.056,11.34q0,1.465,0,2.933c29.747-2.5,29.852-17.474,29.852-17.49C1235.543,114.688,1235.625,93.026,1235.625,93.026Z",
  transform: "translate(-1205.513 7.116)",
  fill: "url(#b)"
})), React.createElement("g", {
  transform: "translate(166.639 14.798)"
}, React.createElement("path", {
  d: "M1313.711,16.2c28.563,0,51.86,20.892,51.86,46.509a43.861,43.861,0,0,1-6.885,23.071,12.851,12.851,0,0,1,8.507,11.809c0,7.268-6.482,13.082-14.585,13.082a15.022,15.022,0,0,1-13.37-7.632,54.082,54.082,0,0,1-25.526,6.178c-28.563,0-51.859-20.895-51.859-46.509S1285.148,16.2,1313.711,16.2Zm0,69.763c14.384,0,25.931-10.356,25.931-23.254s-11.547-23.254-25.931-23.254-25.931,10.356-25.931,23.254S1299.328,85.964,1313.711,85.964Z",
  transform: "translate(-1261.852 -16.201)",
  fill: "url(#g)"
}), React.createElement("path", {
  d: "M1310.848,42.768s-6.4,9.347-19.448,17.259a13.538,13.538,0,0,0,4.211,4.751c4.207,3.067,11.9,4.932,19.444-.9,5.366-4.146,5.128-11.519,2.349-15.837A14.594,14.594,0,0,0,1310.848,42.768Z",
  transform: "translate(-1214.014 26.812)",
  fill: "url(#h)"
})), React.createElement("g", {
  transform: "translate(271.762 20.549)"
}, React.createElement("path", {
  d: "M1378.972,105.6a57.459,57.459,0,0,1-25.122,5.812c-28.561,0-51.859-20.892-51.859-46.506V30.026c0-6.359,5.875-11.629,12.964-11.629s12.967,5.27,12.967,11.629v34.88c0,12.9,11.547,23.254,25.928,23.254s25.931-10.358,25.931-23.254V30.026c0-6.359,5.875-11.629,12.967-11.629s12.964,5.27,12.964,11.629V99.786c0,25.614-23.294,46.509-51.862,46.509a55.082,55.082,0,0,1-36.667-13.627,11,11,0,0,1-3.85-8.174c0-6.178,6.081-11.626,12.964-11.626a13.664,13.664,0,0,1,9.12,3.449,27.88,27.88,0,0,0,18.433,6.723C1366.007,123.041,1376.135,115.592,1378.972,105.6Z",
  transform: "translate(-1301.99 -18.397)",
  fill: "url(#i)"
}), React.createElement("path", {
  d: "M1345.792,75.714s24.841-8.588,26.743-38.838v29.6a43.589,43.589,0,0,1-16.7,37.544,58.626,58.626,0,0,1-33.422,12.354V93.1S1341,92.3,1345.792,75.714Z",
  transform: "translate(-1268.931 11.521)",
  fill: "url(#j)"
}))), React.createElement("text", {
  transform: "translate(1745.373 1141.253)",
  fontSize: 75,
  fontFamily: "SegoeUI, Segoe UI"
}, React.createElement("tspan", {
  x: 0,
  y: 0
}, "PayDay")));

var SvgPaydaylogoText = function SvgPaydaylogoText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 375.521,
    height: 217.026,
    viewBox: "0 0 375.521 217.026",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaydaylogoText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paydaylogoText.922a3b8f.svg";
export { ForwardRef as ReactComponent };